<footer class="am-footer">
  <div class="container-fluid">
    <div class="footer-content">
      <!-- Language Selector -->
      <div class="language-section">
        <select class="language-selector"
                [(ngModel)]="currentLanguage"
                (change)="onLanguageChange($event)"
                aria-label="Select language">
          <option *ngFor="let lang of availableLanguages"
                  [value]="lang.code">
            {{ lang.name }}
          </option>
        </select>
      </div>

      <!-- Copyright -->
      <div class="copyright-section">
        <span>© {{ currentYear }} {{ 'FOOTER.COPYRIGHT' | translate }}</span>
      </div>

      <!-- Version -->
      <div class="version-section">
        <span class="version-text">{{ 'FOOTER.VERSION' | translate }}{{ appVersion }}</span>
        <a *ngIf="_authService.is_user_authenticated()" href="/whats-new" class="small ms-2"
           (click)="openWhatsNew($event)">What's New</a>
      </div>
    </div>
  </div>
</footer>
